import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelIsPrint = (
    state: IApplicationState
): boolean => {
    return getAsidePanel(state).isPrint;
};
